import React from "react";
import styles from "./style.module.css";

export interface ThemeOption {
  id: string;
  name: string;
  img: string;
  preview: string;
  demoUrl: string;
}

interface ThemeSelectorProps {
  themes: ThemeOption[];
  selectedTheme: string;
  onThemeSelect: (themeId: string) => void;
  error?: string;
}

const ThemeSelector: React.FC<ThemeSelectorProps> = ({
  themes,
  selectedTheme,
  onThemeSelect,
  error,
}) => {
  return (
    <div className={styles.themeSelector}>
      <div className={styles.themeGrid}>
        {themes.map((theme) => (
          <div
            key={theme.id}
            className={`${styles.themeBox} ${
              selectedTheme === theme.id ? styles.selected : ""
            } ${error && !selectedTheme ? styles.errorBox : ""}`}
            onClick={() => onThemeSelect(theme.id)}
          >
            {/* Radio Button */}
            <div className={styles.radioContainer}>
              <div
                className={`${styles.radio} ${
                  selectedTheme === theme.id ? styles.radioSelected : ""
                }`}
              >
                {selectedTheme === theme.id && (
                  <div className={styles.radioTick}>✓</div>
                )}
              </div>
            </div>

            {/* Theme Preview */}
            <div className={styles.previewContainer}>
              <img
                src={theme.img}
                alt={theme.name}
                
                className={styles.preview}
              />
              <div className={styles.overlay} />
            </div>

            {/* Theme Name */}
            <div
              className={`${styles.themeName} flex justify-between items-center py-3 px-10`}
            >
              <p className="text-primary-500">
                <a
                  href={theme.demoUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  نمونه
                </a>
              </p>
              <h3>{theme.name}</h3>
            </div>
          </div>
        ))}
      </div>
      {/* {error && (
        <div className={styles.errorMessage}>
          {error}
        </div>
      )} */}
    </div>
  );
};

export default ThemeSelector;
